import Axios from "axios";
export default {
  name: "ToolCode",
  props: ['title', 'baseUrl', 'dateType'],
  data: function data() {
    return {
      loading_code: false,
      formData: {
        value: "",
        date: ""
      }
    };
  },
  methods: {
    onDateChanged: function onDateChanged(date) {
      this.formData.date = date;
    },
    getValue: function getValue() {
      var _this = this;
      var url = "".concat(this.baseUrl, "?date=").concat(this.formData.date);
      this.loading_code = true;
      Axios.get(url).then(function (resp) {
        var _resp$data = resp.data,
          code = _resp$data.code,
          password = _resp$data.password;
        if (code !== 0) {
          return;
        }
        _this.formData.value = password;
      }).finally(function () {
        _this.loading_code = false;
      });
    }
  },
  created: function created() {
    if (this.dateType === 'date') {
      this.formData.date = this.$moment().format('YYYY-MM-DD');
    }
    if (this.dateType === 'datetime') {
      this.formData.date = this.$moment().format('YYYY-MM-DD HH:mm:ss');
    }
    this.getValue();
  }
};